export const ACCESS_TOKEN = "authToken";
export const USER_ID = "userId"
export const USER_INFO = "user-info"
export const TENANTS = "tenants";
export const CLIENT_NAME = "clientName";